<template>
    <div>
        <li class="m_li" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;" class="f r_fle"  @click="category"></a>
            <p class="r_av m_tr" :style="active">网站分类<em class="r_vt">◆</em></p>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
        }
    },
    methods:{
        category(){
            //指定跳转地址
			this.$router.push('/category')
        },
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/right-category.vue